<template>
  <div id="header" class="cover">
    <div class="bar">
      <div class="container">
        <div class="headerLogo"><img src="../assets/logo_w@svg.svg" alt="六角西餐聽"></div>
        <ul class="nav-t clearfix">
          <li><router-link to="/">首頁</router-link></li>
          <li><router-link to="/signup">註冊</router-link></li>
          <li><router-link to="/login">登入</router-link></li>
          <li><router-link to="/cart">購物車</router-link></li>
        </ul>
        <a href="#" class="nav-m" @click="nav">
          <i class="icon-menu"></i>
        </a>
      </div>
    </div>
    <div class="glassBack">
      <p class="slogan">咬一口<br>就無法忘懷的滋味</p>
      <p class="slogan-t">咬一口就無法忘懷的滋味<p>
      <p class="event">七夕絕對無法錯過的好機會<br><i class="icon-burger"></i>六角大漢堡<i class="icon-burger"></i></p>
    </div>
  </div>
</template>

<script>
 export default {
  name: 'coverHeader',
  methods: {
    nav: () => {
      var condition = document.querySelector('.nav-t').style.display;
      if (condition == '') {
        document.querySelector('.nav-t').style.display="block";
      } else if (condition == 'none') {
        document.querySelector('.nav-t').style.display="block";
      } else {
        document.querySelector('.nav-t').style.display="none";
      }
      
    }
  }
 }
</script>

<style lang="scss" scoped>
  .bar {
    padding: 0 13px;
    height: 56px;
    background: rgba(0,0,0,0.75);
    .container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
    }
  }
  .cover {
    height: 420px;
    width: 100%;
    background-color: #3D1101;
    background-image: url("../assets/header_mobile.png");
    background-position: center;
    background-repeat: no-repeat;
    .container {
      width: 100%;
    }
    .icon-menu {
      color: #fff;
      font-size: 24px;
    }
    .nav-t {
      display: none;
      list-style: none;
      li {
        float: left;
        margin-left: 20px;
      }
      a {
        color: #fff;
        text-decoration: none;
      }
    }
    .glassBack {
      width: 95%;
      margin: 57px auto 0 auto;
      padding: 20px 6px;
      background: rgba(0,0,0,0.35);
      text-align: center;
      p {
        margin: 0;
      }
      .slogan, .slogan-t {
        font-size: 36px;
        color: #FFFFFF;
      }
      .slogan-t {
        display: none;
      }
      .event {
        margin-top: 1rem;
        font-size: 16px;
        color: #FFFFFF;
      }
    }
  }

  @media (min-width: 768px) {
    .cover {
      background-image: url('../assets/header_desktop.png');
      .nav-m {
        display: none;
      }
      .nav-t {
       display: block;
      }
      .glassBack {
        width: 60%;
        .slogan {
          display: none;
        }
        .slogan-t {
          display: block;
        }
      }
    }
  }
  @media (min-width: 992px) {
    .cover {
      .container {
         width: 90%;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/coverHeader.vue